/* eslint-disable */
import _m0 from "protobufjs/minimal";
const protobufPackageSarasa = "decentraland.sdk.components";
function createBasePBVisibilityComponent() {
    return { visible: undefined };
}
/**
 * @public
 */
export var PBVisibilityComponent;
(function (PBVisibilityComponent) {
    function encode(message, writer = _m0.Writer.create()) {
        if (message.visible !== undefined) {
            writer.uint32(8).bool(message.visible);
        }
        return writer;
    }
    PBVisibilityComponent.encode = encode;
    function decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePBVisibilityComponent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.visible = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    PBVisibilityComponent.decode = decode;
})(PBVisibilityComponent || (PBVisibilityComponent = {}));
